import React from "react";
import { useSelector } from "react-redux";

import HeaderSection from "./HeaderSection";
import ProfitCard from "./ProfitCard";
import ExpenseTable from "./ExpenseTable";
import ExpenseInfo from "./ExpenseInfo";
import messages from "../../../assets/locale/messages";
import netProfitIcon from "../../../assets/images/icons/card-send.svg";
import settledProfitIcon from "../../../assets/images/icons/money-tick.svg";
import unSettledProfitIcon from "../../../assets/images/icons/money-time.svg";
import expensesIcon from "../../../assets/images/icons/card-receive.svg";
import { useExpenseTable } from "./ExpenseTable/useExpenseTable";
import "./index.scss";

const MimarProfit = () => {
  const lang = useSelector((state) => state.locale.lang);
  const mimarProfitData = useSelector((state) => state.expenses.mimarProfit);

  const expenseTableHook = useExpenseTable();
  const {
    fromDateFilterValue,
    toDateFilterValue,
    handleFromDateChange,
    handleToDateChange,
    fromDateHasError,
    toDateHasError,
  } = expenseTableHook;

  const { mimarProfit } = messages[lang];
  const expenseInfo = mimarProfit.expenseInfo;

  const profitCards = [
    {
      name: mimarProfit.profitCards.netProfit.name,
      value: mimarProfitData.net_profit,
      infoText: mimarProfit.profitCards.netProfit.infoText,
      expenseTitle: mimarProfit.profitCards.netProfit.expenseTitle,
      expensenetProfitIconInfo: mimarProfit.profitCards.netProfit.expenseInfo,
      icon: netProfitIcon,
      iconBg: "#E8F5DB",
    },
    {
      name: mimarProfit.profitCards.settledProfit.name,
      value: mimarProfitData.settled_profit,
      infoText: mimarProfit.profitCards.settledProfit.infoText,
      expenseTitle: mimarProfit.profitCards.settledProfit.expenseTitle,
      expenseInfo: mimarProfit.profitCards.settledProfit.expenseInfo,
      icon: settledProfitIcon,
      iconBg: "#DDF5FF",
    },
    {
      name: mimarProfit.profitCards.unSettledProfit.name,
      value: mimarProfitData.unsettled_amount,
      infoText: mimarProfit.profitCards.unSettledProfit.infoText,
      icon: unSettledProfitIcon,
      iconBg: "#FFF7E6",
    },
    {
      name: mimarProfit.profitCards.expenses.name,
      value: mimarProfitData.expenses,
      infoText: mimarProfit.profitCards.expenses.infoText,
      icon: expensesIcon,
      iconBg: "#FEECEC",
    },
  ];

  return (
    <>
      <HeaderSection
        showActions={true}
        fromDateFilterValue={fromDateFilterValue}
        toDateFilterValue={toDateFilterValue}
        handleFromDateChange={handleFromDateChange}
        handleToDateChange={handleToDateChange}
        fromDateHasError={fromDateHasError}
        toDateHasError={toDateHasError}
      />
      <div className="mb-2 mb-lg-3">
        {expenseInfo && (
          <ExpenseInfo
            key={`vat-${expenseInfo.expenseTitle}`}
            expenseTitle={
              expenseInfo.expenseTitle +
              `: ${Number(mimarProfitData?.total_vat ?? 0)} ${
                expenseInfo.label
              }`
            }
            infoText={expenseInfo.expenseInfoText}
          />
        )}
      </div>
      <div className="profit-grid mb-4 mb-lg-5">
        {profitCards.map((card) => (
          <div key={card.name}>
            <ProfitCard
              name={card.name}
              value={card.value}
              infoText={card.infoText}
              icon={card.icon}
              iconBg={card.iconBg}
              iconColor={card.iconColor}
            />
          </div>
        ))}
      </div>
      <ExpenseTable expenseTableHook={expenseTableHook} />
    </>
  );
};
export default MimarProfit;
